<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.BmiCalculator.title') }}</span>
      <span class="fmt-spacer"/>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>

    <!-- 输入区 -->
    <div class="bmi-inputs">
      <div class="bmi-field">
        <span class="bmi-field-label">{{ $t('tool.BmiCalculator.height') }}</span>
        <div class="bmi-input-row">
          <input class="bmi-input" v-model="height" placeholder="170" @input="calc" spellcheck="false"/>
          <span class="bmi-unit">cm</span>
        </div>
      </div>
      <div class="bmi-field">
        <span class="bmi-field-label">{{ $t('tool.BmiCalculator.weight') }}</span>
        <div class="bmi-input-row">
          <input class="bmi-input" v-model="weight" placeholder="65" @input="calc" spellcheck="false"/>
          <span class="bmi-unit">kg</span>
        </div>
      </div>
    </div>

    <!-- 结果 -->
    <div class="bmi-result" v-if="result">
      <div class="bmi-gauge">
        <div class="bmi-gauge-bar">
          <div class="bmi-gauge-fill" :style="{width:gaugePct+'%',background:gaugeColor}"/>
          <div class="bmi-gauge-dot" :style="{left:gaugePct+'%'}"/>
        </div>
        <div class="bmi-gauge-labels">
          <span style="left:0%">10</span><span style="left:25%">18.5</span>
          <span style="left:49%">24</span><span style="left:73%">28</span>
          <span style="right:0">40</span>
        </div>
      </div>
      <div class="bmi-val">{{ result.val }} <span>kg/m²</span></div>
      <div class="bmi-cat" :style="{color:result.color}">{{ result.label }}</div>
      <div class="bmi-ideal">{{ $t('tool.BmiCalculator.idealWeight', { min: result.idealMin, max: result.idealMax }) }}</div>
    </div>

    <div class="fmt-status-bar" v-else>
      <span class="fmt-hint">{{ $t('tool.BmiCalculator.hint') }}</span>
    </div>
  </div>
</template>

<script>
var CAT_KEYS = ['underweight','normal','overweight','obese']
var CATS = [
  { max: 18.5, key: CAT_KEYS[0], color: '#909399' },
  { max: 24, key: CAT_KEYS[1], color: '#43a047' },
  { max: 28, key: CAT_KEYS[2], color: '#e6a23c' },
  { max: 99, key: CAT_KEYS[3], color: '#e74c3c' }
]

export default {
  name: 'BmiCalculatorTool',
  props: { config: { type: Object, default: function() { return {} } } },
  data: function() { return { height: '', weight: '', result: null } },
  computed: {
    gaugePct: function() {
      if (!this.result) return 0
      return Math.min(100, Math.max(0, (this.result.val - 10) / 30 * 100))
    },
    gaugeColor: function() {
      if (!this.result) return '#909399'
      return this.result.color
    }
  },
  methods: {
    calc: function() {
      var h = parseFloat(this.height), w = parseFloat(this.weight)
      if (!h || !w || h < 50 || h > 250 || w < 10 || w > 300) { this.result = null; return }
      var bmi = Math.round(w / ((h / 100) * (h / 100)) * 10) / 10
      var cat = CATS[0]
      for (var i = 0; i < CATS.length; i++) { if (bmi < CATS[i].max) { cat = CATS[i]; break } }
      var idealMin = Math.round(18.5 * (h / 100) * (h / 100) * 10) / 10
      var idealMax = Math.round(24 * (h / 100) * (h / 100) * 10) / 10
      this.result = { val: bmi, label: this.$t('tool.BmiCalculator.'+cat.key), color: cat.color, idealMin: idealMin, idealMax: idealMax }
    },
    clearAll: function() { this.height = ''; this.weight = ''; this.result = null },
    doAction: function(a) { if (a === 'clear') this.clearAll() }
  }
}
</script>

<style scoped>
.fmt-tool{display:flex;flex-direction:column;gap:16px;max-width:100%}

.fmt-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.fmt-toolbar >>> .el-button + .el-button{margin-left:0}
.fmt-label{font-size:13px;font-weight:700;color:#1a1f36}
.fmt-spacer{flex:1}

/* 输入 */
.bmi-inputs{display:flex;gap:16px;width:100%}
.bmi-field{flex:1;min-width:0;background:#fafbfc;border:1px solid #ebeef5;border-radius:12px;padding:18px 20px}
.bmi-field-label{display:block;font-size:12px;font-weight:700;color:#909399;margin-bottom:10px}
.bmi-input-row{display:flex;align-items:center;gap:8px}
.bmi-input{flex:1;min-width:0;border:1.5px solid #e1e5e9;border-radius:10px;padding:12px 16px;font-size:22px;font-family:'SF Mono',Menlo,Consolas,monospace;text-align:center;outline:none;color:#1a1f36;background:#fff;transition:.15s}
.bmi-input:focus{border-color:#4e7cff;box-shadow:0 0 0 3px rgba(78,124,255,.06)}
.bmi-input::placeholder{color:#d0d4dc;font-size:16px}
.bmi-unit{font-size:13px;color:#b0b8c4;font-weight:600}

/* 结果 */
.bmi-result{text-align:center;background:#fafbfc;border:1px solid #ebeef5;border-radius:14px;padding:28px 24px}
.bmi-gauge-bar{position:relative;height:12px;background:#f0f2f5;border-radius:6px;margin-bottom:6px}
.bmi-gauge-fill{height:100%;border-radius:6px;transition:width .4s ease}
.bmi-gauge-dot{position:absolute;top:-4px;width:20px;height:20px;border-radius:50%;background:#fff;border:3px solid #1a1f36;transform:translateX(-50%);transition:left .4s ease}
.bmi-gauge-labels{position:relative;height:20px;font-size:10px;color:#b0b8c4}
.bmi-gauge-labels span{position:absolute;transform:translateX(-50%)}
.bmi-gauge-labels span:last-child{transform:none}
.bmi-val{font-size:44px;font-weight:700;color:#1a1f36;line-height:1.2;margin-top:12px}
.bmi-val span{font-size:16px;font-weight:400;color:#909399}
.bmi-cat{font-size:20px;font-weight:600;margin-top:4px}
.bmi-ideal{font-size:13px;color:#909399;margin-top:12px;padding:8px 16px;background:#fff;border-radius:8px;display:inline-block}

.fmt-status-bar{font-size:12px}
.fmt-hint{color:#c0c4cc}

@media(max-width:400px){.bmi-inputs{flex-direction:column}}
</style>
